import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { useAISummaryStore } from "../store/aiSummaryStore";

export function useFetchAISummaryNote() {
  const aiSummaryRepository = useService("repositories/ai-summary-repository");
  const { setSelectedSummaryNoteContent, setSummaryNoteLoading } = useAISummaryStore();

  const fetchAISummaryNote = async (uuid) => {
    try {
      setSummaryNoteLoading(true);
      const res = await aiSummaryRepository.findRecord(uuid);
      setSelectedSummaryNoteContent(res?.content ?? null);
    } catch (error) {
      console.error(error);
      return ApiRequestErrorHandler(error);
    } finally {
      setSummaryNoteLoading(false);
    }
  };

  return { fetchAISummaryNote };
}
